export default __webpack_public_path__ + "static/media/msg.6c7f1111.svg";